// extracted by mini-css-extract-plugin
module.exports = {"brand":"Logo_brand__2s0il","logo-title":"Logo_logo-title__XkH3d"};